module.exports = __webpack_public_path__ + "static/media/coatings_advantages.7b4c8e24.jpg";